import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

class RZScrollBar extends React.Component {

    constructor(props) {
        super(props);
        if (!this.props.size) {
            this.props.size = {
                height: '600px',
                'width': '100%'
            }
        }
    }
    customScrollBarTrack() {
        let style = {
            position: 'absolute',
            width: '10px',
            right: '20px',
            bottom: '2px',
            top: '2px',
            'borderRadius': '3px',
            'backgroundColor': 'var(--rzgray3)'
        }
        return <div style={style} className="track-vertical" />
    }

    customScrollBarThumb(style, ...props) {
        let custStyle = {
            ...style,
            'backgroundColor': 'var(--rzgreen)'
        }
        return <div style={custStyle} className="track-vertical-thumb" />
    }
    render() {
        return (
            <Scrollbars hideTracksWhenNotNeeded={true} style={this.props.size}
                renderTrackVertical={this.customScrollBarTrack}
                renderThumbVertical={this.customScrollBarThumb}>
                {this.props.content}
            </Scrollbars>
        );
    }
}
export default RZScrollBar;
